import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

export const PrincipleRow = ({
  number,
  glyph,
  title,
  description,
}: {
  number: string;
  glyph: string;
  title: string;
  description: ReactNode;
}) => (
  <Box
    data-about-principle={number}
    component="article"
    sx={{
      minHeight: { sm: 260 },
      p: { xs: 2, md: 2.5 },
      border: "1px solid",
      borderColor: number === "02" ? "secondary.main" : "divider",
      bgcolor: number === "02" ? "secondary.main" : "background.paper",
      color: number === "02" ? "background.default" : "text.primary",
      display: "flex",
      flexDirection: "column",
      transition: "transform .18s ease, box-shadow .18s ease",
      "&:hover": {
        transform: "translate(-4px,-4px)",
        boxShadow: number === "02" ? "6px 6px 0 #f0ece2" : "6px 6px 0 #ff3d12",
      },
    }}
  >
    <Box sx={{ display: "flex", alignItems: "start", justifyContent: "space-between", gap: 2 }}>
      <Typography sx={{ fontSize: ".7rem", fontWeight: 900, letterSpacing: ".1em" }}>{number}</Typography>
      <Typography
        aria-hidden
        sx={{ fontFamily: '"Noto Sans Symbols 2", sans-serif', fontSize: "2.5rem", lineHeight: 1 }}
      >
        {glyph}
      </Typography>
    </Box>
    <Typography
      component="h3"
      sx={{
        mt: "auto",
        pt: 4,
        fontSize: { xs: "1.25rem", md: "1.6rem" },
        fontWeight: 950,
        textTransform: "uppercase",
        letterSpacing: "-.045em",
        lineHeight: 0.95,
      }}
    >
      {title}
    </Typography>
    <Typography
      variant="body2"
      sx={{ mt: 1.5, color: number === "02" ? "inherit" : "text.secondary", lineHeight: 1.65 }}
    >
      {description}
    </Typography>
  </Box>
);
